import React from 'react';
import SAPopover from "../../common/confirmation/SAPopover";
import {injectIntl} from "react-intl";
import Constants from "../../../services/Constants";
import connect from "react-redux/es/connect/connect";
import moment from "moment";
import Time from "../../../services/Time";
import SACheckbox from "../../common/input/SACheckbox";
import {Col, Row} from "antd";
import Intervention from "../../../services/Intervention";


class VehicleReadyPopover extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      notify:true,
    }
  }

  componentDidMount() {
    this.props.dispatchFetchOpeningHours();
  }

  onVisibleChange = (visible) => {
    this.setState({visible})
  };

  onCancel = () => {
    this.setState({visible: false})
  };

  onConfirm = () => {
    const {notify} = this.state;
    this.props.onConfirm({propose247: false, notify});
    this.setState({visible: false})
  };

  onPropose247 = () => {
    const {notify} = this.state;
    this.props.onConfirm({propose247: true, notify});
    this.setState({visible: false})
  };

  propose247Enabled = () => {
    const {intervention: {journey: {properties}}, mainServices: {offering: {rentalDropOff, carPickup} = {}} = {}} = this.props;
    const {mobility} = properties.mobility;

    const requestedRental = Constants.MOBILITY_VEHICLES.includes(mobility.name);
    return (requestedRental && rentalDropOff) || (!requestedRental && carPickup);
  };

  renderPopContent = () => {
    const {intl: {formatMessage}, allow247Pickup} = this.props;
    const {notify} = this.state;


    return (
      <div>
        <Row type="flex" justify="center" style={{paddingBottom:'10px'}}>
          <Col>
            <SACheckbox checked={notify} onChange={e=>this.setState({notify : e.target.checked})}>{formatMessage({id:'notify.vehicle-ready'})}</SACheckbox>
          </Col>
        </Row>
      <Row type="flex" justify="center" gutter={16}>
        <Col span={8}>
          <button className="btn btn-sm btn-o-secondary" onClick={this.onCancel}>{formatMessage({id:'button.cancel'})}</button>
        </Col>
        <Col span={8}>
          <button className="btn btn-sm btn-primary" onClick={this.onConfirm}>{formatMessage({id:'button.confirm'})}</button>
        </Col>
        {allow247Pickup && this.propose247Enabled() &&
        <Col span={8}>
            <button className="btn btn-sm btn-primary" onClick={this.onPropose247}>{formatMessage({id: 'button.confirm.propose.247'})}</button>
          </Col>
        }
      </Row>
      </div>
    )
  };

  render() {
    const {intl: {formatMessage}} = this.props;
    const {visible} = this.state;

    return (
      <SAPopover action="vehicle-ready"
                 trigger="click"
                 content={this.renderPopContent()}
                 visible={visible}
                 placement="bottom"
                 onVisibleChange={this.onVisibleChange}>
        <button className="btn btn-primary">{formatMessage({id:'button.vehicle-ready'})}</button>
      </SAPopover>
    )
  }
}

const mapStateToProps = state => {
  let allow247Pickup = false;
  const dealerOpeningHours = state.fetchOpeningHours.openingHours &&  state.fetchOpeningHours.openingHours.dealerOpeningHours;
  const intervention = state.fetchIntervention && state.fetchIntervention.intervention;

  if (dealerOpeningHours && !Intervention.isWeb(intervention)){
    const currentDay =  dealerOpeningHours[Time.dayOfWeekAsStringUppercase(moment())];
    const closeTime = currentDay && currentDay.slots && currentDay.slots[currentDay.slots.length - 1].closeTime || "18:00:00";
    const pickup247Limit = moment(closeTime, 'HH:mm:ss').subtract(Constants.VEHICLE_READY_LIMIT_TO_ANSWER, 'minutes');
    allow247Pickup = moment().isBefore(pickup247Limit);
  }
  return {
    allow247Pickup,

  }
};

const mapDispatchToProps = dispatch => ({
  dispatchFetchOpeningHours: () => dispatch({type: 'FETCH_OPENING_HOURS.REQUEST'}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(VehicleReadyPopover))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/vehicleready/VehicleReadyPopover.js